import Input from "atoms/input/Input";
import { TOAST_TYPES } from "enum/enums";
import { handleErrorMessage } from "lib/utils";
import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { addToast } from "store/toaster/reducer";
import styles from "./RegisterKey.module.scss";
import { MenuItem, Select } from "@mui/material";

type FormValues = {
	apiKeyName: string;
	apiKeyType: string;
};

interface RegisterKeyProps {
	getRegistered: (name: string, type: string) => Promise<void>;
	handleShowModal: () => void;
}

const RegisterKey: React.FC<RegisterKeyProps> = ({ getRegistered, handleShowModal }) => {
	const dispatch = useDispatch();

	const {
		register,
		handleSubmit,
		reset,
		formState: { errors, isSubmitting },
		watch,
		setValue,
	} = useForm<FormValues>({
		defaultValues: {
			apiKeyName: "",
			apiKeyType: "publishable",
		},
	});

	const onSubmit = async (data: FormValues) => {
		try {
			await getRegistered(data.apiKeyName, data.apiKeyType);
			reset();
			// handleShowModal()
		} catch (error) {
			console.log(error);
			dispatch(addToast({ type: TOAST_TYPES.ERROR, message: handleErrorMessage(error) }));
		}
	};

	return (
		<div className={styles.registerKey}>
			<h2>Create API Key</h2>
			<form onSubmit={handleSubmit(onSubmit)}>
				<Input
					type="text"
					label="API Key"
					register={register}
					placeholder="Enter your API key name"
					required
					inputName="apiKeyName"
					errorMessage={
						errors.apiKeyName
							? errors.apiKeyName.message
								? errors.apiKeyName.message
								: "API Key name is required"
							: ""
					}
					disabled={isSubmitting}
				/>

				{/* Dropdown for API key type */}
				<div className={styles.registerKey__select}>
					<label htmlFor="apiKeyType">API Key Type</label>
					<Select
						id="apiKeyType"
						value={watch("apiKeyType")}
						onChange={(e) => setValue("apiKeyType", e.target.value)}
						fullWidth
						disabled={isSubmitting}
					>
						<MenuItem value="publishable">Publishable</MenuItem>
						<MenuItem value="secret">Secret</MenuItem>
					</Select>
				</div>

				<div className={`flex justify-end ${styles.registerKey__button}`}>
					<button
						className="outline button sm"
						disabled={isSubmitting}
						type="button"
						onClick={handleShowModal}
					>
						Cancel
					</button>
					<button className="button sm" disabled={isSubmitting} type="submit">
						Register
					</button>
				</div>
			</form>
		</div>
	);
};

export default RegisterKey;
